// extracted by mini-css-extract-plugin
export default {"link":"HZoh6Q7Pz35l6AAvh3rl"};